import { collectionConstants } from '../Constants';
import { collectionService } from '../Services';

export const collectionActions = {
    getCollections,
    postUploadCollections,
    postAuth
}

function getCollections(TOKEN) {
    return dispatch => {
        dispatch(request());

        collectionService.getCollections(TOKEN)
            .then(
                collections => dispatch(success(collections)),
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: collectionConstants.GET_COLLECTIONS_REQUEST } }
    function success(collections) { return { type: collectionConstants.GET_COLLECTIONS_SUCCESS, collections } }
    function failure(error) { return { type: collectionConstants.GET_COLLECTIONS_FAILURE, error } }
}

function postUploadCollections(collection, TOKEN) {
    return dispatch => {
        dispatch(request());

        collectionService.postUploadCollections(collection, TOKEN)
            .then(
                uploadCollection => dispatch(success(uploadCollection)),
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: collectionConstants.POST_UPLOAD_COLLECTIONS_REQUEST } }
    function success(uploadCollection) { return { type: collectionConstants.POST_UPLOAD_COLLECTIONS_SUCCESS, uploadCollection } }
    function failure(error) { return { type: collectionConstants.POST_UPLOAD_COLLECTIONS_FAILURE, error } }
}

function postAuth(auth) {
    return dispatch => {
        dispatch(request());
        collectionService.postAuth(auth)
            .then(
                auth => dispatch(success(auth)),
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: collectionConstants.POST_AUTH_REQUEST } }
    function success(auth) { return { type: collectionConstants.POST_AUTH_SUCCESS, auth } }
    function failure(error) { return { type: collectionConstants.POST_AUTH_FAILURE, error } }
}